import { promotionDetailPut } from "#api/Api/promotions"
import { Box, Stack, Typography } from "@mui/material"
import { validation } from "Components/Vacantes/FormularioVacante/FormularioVacante"
import { useCallback, useEffect, useMemo, useState } from "react"
import { usePromotionsContext } from "../../PromotionContext"

export function ResponseTrue({ setMaxWidth, setButtons }) {
	const {
		response,
		promotionDetail,
		setOpenConfirm: setOpen,
		reload,
	} = usePromotionsContext()
	const [buttonDisabled, setButtonDisabled] = useState(false)
	const colaboradores = [
		{
			id: promotionDetail.authorization,
			full_name: promotionDetail.authorization_name,
		},
		{
			id: promotionDetail.colaborador_id,
			full_name: promotionDetail.colaborador_name,
		},
	]
	const sucursales = [
		{ id: promotionDetail.sucursal_id, nombre: promotionDetail.sucursal_name },
	]
	const perfiles = [
		{
			id: promotionDetail.old_profile_id,
			nombre: promotionDetail.old_profile_name,
		},
	]
	const [sendResponse, setSendResponse] = useState({
		authorized: true,
		new_vacante: false,
	})

	const success = useMemo(
		() => (response) => {
			if (response) {
				setOpen(false)
				reload()
			}
			return false
		},
		[reload, setOpen]
	)

	const onClick = useCallback(() => {
		if (sendResponse.new_vacante && !validation(sendResponse)) {
			return
		}
		setButtonDisabled(true)
		promotionDetailPut(promotionDetail.id, sendResponse, {
			success,
			end: () => setButtonDisabled(false),
		})
	}, [promotionDetail, sendResponse, success])

	useEffect(() => {
		if (response === true)
			setButtons([
				{
					label: "Cancelar",
					onClick: () => setOpen(false),
					disabled: buttonDisabled,
				},
				{
					label: "Aceptar",
					onClick,
					disabled: buttonDisabled,
				},
			])
	}, [buttonDisabled, onClick, response, setButtons, setOpen])

	if (!response) return null
	return (
		<Box>
			<Stack spacing={3} alignItems={"center"}>
				<Typography variant="body2" textAlign={"center"}>
					¿Estas seguro de aprobar la promoción de{" "}
					<strong>{promotionDetail.colaborador_name}</strong> para el puesto{" "}
					<strong>{promotionDetail.new_profile}</strong>?
				</Typography>
			</Stack>
		</Box>
	)
}
